export default __webpack_public_path__ + "static/media/logo.4c059a39.png";